export const checkMaintenance = (data , navigate) => {
    if(data && data.state && data.state === "maintenance") {
        navigate("/maintenance");
    }
}